module.exports = __webpack_public_path__ + "static/img/func-1.f5124c54.png";